// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"FormErrorMessage_errorMsg__1pXkg"};